<template>
    <span v-if="data_qst_ans!=undefined && data_qst_ans.value!=undefined">
        <span v-if="prop_qst_show_bools_as_sym">
            <span v-if="data_qst_ans.name=='Yes' || data_qst_ans.name=='yes'">
                <v-icon color="green" medium>mdi-triangle</v-icon>
            </span>
            <span v-else-if="data_qst_ans.name=='No' || data_qst_ans.value=='no'">
                <v-icon color="red" medium style="transform: rotate(180deg);">mdi-triangle</v-icon>
            </span>
            <span class="app-class-text-light" v-else>
                {{data_qst_ans.name}}
            </span>
        </span>
        <span v-else>
            <span>{{data_qst_ans.name}}</span>
        </span>
    </span>
    <span v-else>
        <span>-</span>
    </span>
</template>

<script>
//########################################
//IMPORTS libs
//########################################

//########################################
//IMPORTS components
//########################################

//########################################
//MAIN
//########################################
export default {
    name: 'ComponentColorCoderBool',

    props:[
        'prop_qst_model',
        'prop_qst_show_bools_as_sym'
    ],

    computed:{
        data_qst_ans:function()
        {
            return this.prop_qst_model == undefined ? undefined :this.prop_qst_model.selected_options[0]
        }
    }
}

//call all with signature func_imp.call(this,param_1,param_2)
//############################################
//HELPERS
//############################################

//############################################
//API_REQUESTS
//############################################

//############################################
//DATA_OPPS
//############################################

//############################################
//ACTIONS
//############################################
</script>
